import { useContext } from "react";
import { DisaggregatedMetric } from "../../services/types"
import MetadataContext from "../../context/MetadataContext";
import { DashboardCardWrapper } from "./DashboardCardWrapper";

// Lorem ipsum generator for descriptions
function getLoremIpsum(): string {
  const loremTexts = [
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    "Ut enim ad minim veniam, quis nostrud exercitation.",
    "Duis aute irure dolor in reprehenderit in voluptate.",
    "Excepteur sint occaecat cupidatat non proident.",
    "Sed ut perspiciatis unde omnis iste natus error.",
  ]

  return loremTexts[Math.floor(Math.random() * loremTexts.length)]
}

const SnapshotDashboard = ({ data }: { data: DisaggregatedMetric[] }) => {
  const { metadata: metrics } = useContext(MetadataContext);

  // Create a Set of metric IDs that are of type "index"
  const indexMetricIds = new Set(metrics?.filter((m: any) => m.metric_source_type === "index").map((m: any) => m.id))

  // Filter out items from data whose ID matches an "index" metric
  const filteredData = data.filter((item: any) => !indexMetricIds.has(item.id))

  // Safety check - if data is empty, show a message
  if (!data || data.length === 0) {
    return (
      <main className="bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto py-6 px-4">
          <div className="p-4 border rounded-lg bg-amber-50 text-port-text shadow-sm">
            <p className="font-medium">
              No contextual metric data available for this organization.
            </p>
          </div>
        </div>
      </main>
    )
  }

  // Filter out items without a category
  const validData = filteredData.filter((item: any) => item && item.category)

  // Normalize and group categories case-insensitively
  const categoryMap = new Map<string, { display: string; items: any[] }>()

  validData.forEach((item: any) => {
    const normalized = item.category.toLowerCase()
    const display = item.category.toLowerCase().replace(/(^\w|\s\w)/g, (m: string) => m.toUpperCase())

    if (!categoryMap.has(normalized)) {
      categoryMap.set(normalized, { display, items: [] })
    }

    categoryMap.get(normalized)!.items.push(item)
  })

  // Final arrays to use
  const categories = Array.from(categoryMap.keys())
  const metricsByCategory = Object.fromEntries(
    categories.map((key) => [categoryMap.get(key)!.display, categoryMap.get(key)!.items]),
  )

  return (
    <div>
      <div className="py-4 px-2">
        <div className="mb-4">
            <p className="text-sm text-gray-600 italic">Metrics related to the selected area, organized by category. This section highlights key economic, demographic, equity, and environmental trends to provide a well-rounded view of regional changes over time.</p>
        </div>

        <div className="flex flex-col gap-3 flex-print-block">
            {Object.entries(metricsByCategory).map(([category, items]) => (
                <div className="break-card" key={category}>
                <DashboardCardWrapper
                    key={category}
                    category={category}
                    metrics={items}
                    description={getLoremIpsum()}
                />
                </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default SnapshotDashboard;